import React from 'react';
import './styles/categoriesSection.scss';

function CategoriesSection() {
    const tilesData = [
        {
            number: '01',
            name: 'Bathroom',
            description: 'LOFT COLLECTION',
        },
        {
            number: '02',
            name: 'Bedroom',
            description: 'COLORED COLLECTION',
        },
        {
            number: '03',
            name: 'Living Room',
            description: 'CRAFT SOFA',
        },
        {
            number: '04',
            name: 'Kitchen',
            description: 'HELP IN COOKING',
        },
    ];

    return (
        <section className='categories-mainPage'>
            <h1>SHOP BY ROOM</h1>

            <div className='categories-tiles'>
                {tilesData.map((item, index) => (
                    <div
                        className='photo-tile'
                        style={{
                            backgroundImage: `url('${
                                process.env.PUBLIC_URL
                            }/category${index + 1}.jpg')`,
                        }}
                    >
                        <div className='tile-text'>
                            <p className='tile-name'>
                                {item.number} <span>------</span> {item.name}
                            </p>
                            <p className='tile-description'>
                                {item.description}
                            </p>
                            <p className='tile-text-button'>BUY NOW</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default CategoriesSection;
